// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___34X1a","title":"style__title___1CPO1","loader":"style__loader___L4rk0","optionsContainer":"style__optionsContainer___2J8Hd","optionsContainerSection":"style__optionsContainerSection___OtX7Q","optionsContainerSectionTitle":"style__optionsContainerSectionTitle___12ayu","buttonContainer":"style__buttonContainer___24AtC","button":"style__button___33tKt","buttonActive":"style__buttonActive___3Rzg6","buttonError":"style__buttonError___1yyg_","backButton":"style__backButton___2Ib1k"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-industry-pages/boostabostad/style.css
// module id = 1322
// module chunks = 0